(() => {
  const desktopQuery = window.matchMedia("(min-width: 992px)");

  document
    .querySelectorAll(
      ".shopify-section-collection-page #filterContent, .shopify-section-list-videos-page .list-filter-layout--adaptive #filterContent",
    )
    .forEach((filter) => {
      const controls = filter.closest(".collection-controls");
      const form = filter.querySelector(
        ".collection-filters_form:not(.skeleton)",
      );
      const status = controls?.querySelector(".collection-controls__status");
      const results = controls?.querySelector(".collection-controls__results");
      const initializedDetails = new WeakSet();
      let contentObserver;
      let fitFrame = 0;
      let filterPlaceholder;

      if (!controls || !form || !status || !results) return;

      const isInlineDesktop = () =>
        desktopQuery.matches && !filter.classList.contains("active");

      const shouldOpenInDrawer = (details) =>
        !details.classList.contains("filter-group--product_type") ||
        window.theme?.isBrandCollection;

      const filterHosts = () =>
        Array.from(form.children).filter((element) =>
          element.localName.startsWith("algolia-") ||
          element.hasAttribute("data-adaptive-filter-host"),
        );

      const lockFilterChipWidths = () => {
        if (!desktopQuery.matches) return;

        filterHosts().forEach((host) => {
          if (host.style.getPropertyValue("--collection-filter-chip-width")) {
            return;
          }

          const content =
            host.querySelector(".ymm-filter-group") ||
            host.querySelector("lazy-script") ||
            host;
          const summary = content?.querySelector("summary");
          if (!content || !summary) return;

          const measurement = summary.cloneNode(true);
          const heading =
            measurement.querySelector("#heading") ||
            measurement.querySelector(".fw700");
          const defaultHeading = host.dataset.heading || heading?.textContent;

          if (heading && defaultHeading) heading.textContent = defaultHeading;
          const clearButton = measurement.querySelector(".btn-clear");
          if (host.hasAttribute("data-adaptive-filter-host")) {
            clearButton?.classList.remove("none");
          } else {
            clearButton?.classList.add("none");
          }
          measurement.style.position = "absolute";
          measurement.style.visibility = "hidden";
          measurement.style.width = "max-content";
          measurement.style.maxWidth = "none";
          measurement.style.pointerEvents = "none";
          content.append(measurement);

          const width = Math.ceil(measurement.getBoundingClientRect().width);
          measurement.remove();

          if (width) {
            host.style.setProperty(
              "--collection-filter-chip-width",
              `${width}px`,
            );
          }
        });
      };

      const removeFilterPlaceholder = () => {
        filterPlaceholder?.remove();
        filterPlaceholder = null;
      };

      const createFilterPlaceholder = () => {
        if (!desktopQuery.matches || filterPlaceholder) return;

        filterPlaceholder = document.createElement("div");
        filterPlaceholder.className = "collection-filters-placeholder";

        Array.from(form.children).forEach((child) => {
          if (
            child.matches(
              ".collection-all-filters-button, .collection-controls__results",
            )
          ) {
            filterPlaceholder.append(child.cloneNode(true));
            return;
          }

          const summary = child.querySelector("summary");
          if (!summary) return;

          const item = document.createElement("div");
          item.className = "collection-filter-placeholder-item";
          item.classList.toggle(
            "is-adaptively-hidden",
            child.classList.contains("is-adaptively-hidden"),
          );
          item.style.setProperty(
            "--collection-filter-chip-width",
            child.style.getPropertyValue("--collection-filter-chip-width"),
          );
          item.append(summary.cloneNode(true));
          filterPlaceholder.append(item);
        });

        filter.before(filterPlaceholder);
      };

      const closeDesktopFilters = (exception = null) => {
        if (!isInlineDesktop()) return;

        filter
          .querySelectorAll("details.filter-group[open]")
          .forEach((details) => {
            if (details !== exception) details.open = false;
          });
      };

      const initializeDetails = () => {
        filter.querySelectorAll("details.filter-group").forEach((details) => {
          if (initializedDetails.has(details)) return;
          initializedDetails.add(details);

          const inline = isInlineDesktop();
          details.open = !inline && shouldOpenInDrawer(details);
          details
            .closest("accordion-component")
            ?.toggleAttribute("data-disabled", inline);

          details.addEventListener("toggle", () => {
            if (isInlineDesktop() && details.open) {
              closeDesktopFilters(details);
            }
          });
        });
      };

      const syncDetails = () => {
        initializeDetails();
        const inline = isInlineDesktop();

        filter.querySelectorAll("details.filter-group").forEach((details) => {
          details.open = !inline && shouldOpenInDrawer(details);
          details
            .closest("accordion-component")
            ?.toggleAttribute("data-disabled", inline);
        });
      };

      const restoreResults = () => {
        if (results.parentElement !== status) status.append(results);
        controls.classList.remove("has-inline-results");
      };

      const fitsOnOneLine = () => form.scrollWidth <= form.clientWidth + 1;

      const observeContent = () => {
        contentObserver.observe(form, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["hidden"],
        });
        contentObserver.observe(results, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      };

      const fitDesktopFilters = () => {
        fitFrame = 0;
        contentObserver?.disconnect();

        if (desktopQuery.matches && filter.classList.contains("active")) {
          observeContent();
          return;
        }

        if (!isInlineDesktop()) {
          filterHosts().forEach((host) =>
            host.classList.remove("is-adaptively-hidden"),
          );
          restoreResults();
          observeContent();
          return;
        }

        const hosts = filterHosts();
        lockFilterChipWidths();
        restoreResults();
        hosts.forEach((host) => host.classList.remove("is-adaptively-hidden"));

        for (let index = hosts.length - 1; index >= 0; index -= 1) {
          if (fitsOnOneLine()) break;
          hosts[index].classList.add("is-adaptively-hidden");
        }

        if (results.textContent.trim()) {
          form.append(results);
          if (fitsOnOneLine()) {
            controls.classList.add("has-inline-results");
          } else {
            restoreResults();
          }
        }

        observeContent();
      };

      const scheduleFit = () => {
        if (fitFrame) return;
        fitFrame = window.requestAnimationFrame(fitDesktopFilters);
      };

      const syncLayout = () => {
        if (!filter.classList.contains("active")) {
          removeFilterPlaceholder();
        }
        syncDetails();
        scheduleFit();
      };

      contentObserver = new MutationObserver(() => {
        initializeDetails();
        scheduleFit();
      });
      observeContent();

      new MutationObserver(syncLayout).observe(filter, {
        attributes: true,
        attributeFilter: ["class"],
      });

      if ("ResizeObserver" in window) {
        const resizeObserver = new ResizeObserver(scheduleFit);
        resizeObserver.observe(controls);
        resizeObserver.observe(form);
      } else {
        window.addEventListener("resize", scheduleFit, { passive: true });
      }

      form
        .querySelector(".collection-all-filters-button")
        ?.addEventListener("click", createFilterPlaceholder);

      filter.addEventListener("click", (event) => {
        if (desktopQuery.matches && event.target === filter) {
          filter.requestClose?.();
        }
      });

      document.addEventListener("click", (event) => {
        if (isInlineDesktop() && !filter.contains(event.target)) {
          closeDesktopFilters();
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;

        if (filter.classList.contains("active")) {
          filter.requestClose?.();
        } else {
          closeDesktopFilters();
        }
      });

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener("change", syncLayout);
      } else {
        desktopQuery.addListener(syncLayout);
      }

      syncLayout();
    });
})();
